import React, { useMemo } from 'react'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import { useTheme } from '../ThemeContext'

/**
 * Most między naszym motywem a Material UI.
 *
 * MUI maluje swoje komponenty z WŁASNEJ palety, nie z klas Tailwinda — nie widzi
 * klasy `dark` na <html> ani zmiennych z `index.css`. Bez tego mostu numery stron
 * w paginacji (`ProductPage.jsx`) zostawały czarne na ciemnym tle, a okno filtrów
 * otwierało się jako biały prostokąt.
 *
 * Świadomie NIE dokładamy `CssBaseline` — MUI nadpisałoby wtedy `body`, którym
 * zarządza `index.css`.
 *
 * Kolory poniżej muszą zgadzać się z motywem z `index.css` (`--vv-bg-white`,
 * `--vv-strona`); MUI potrzebuje wartości, nie zmiennych CSS, więc są przepisane.
 */
const MotywMui = ({ children }) => {
  const { ciemny } = useTheme()

  const motyw = useMemo(
    () =>
      createTheme({
        palette: {
          mode: ciemny ? 'dark' : 'light',
          // Firmowy niebieski — ten sam co `blue-600` w Tailwindzie.
          primary: { main: '#2563eb' },
          ...(ciemny && {
            background: { default: '#10151f', paper: '#1c2534' },
            text: { primary: '#f1f5f9', secondary: '#b4c0cf' },
          }),
        },
      }),
    [ciemny]
  )

  return <MuiThemeProvider theme={motyw}>{children}</MuiThemeProvider>
}

export default MotywMui
